import LearnMore from "@features/taboola/components/Disclaimer/LearnMore";
import { getTaboolaDisclaimerText } from "@features/taboola/utils/helpers";
import { useWindowSize } from "@hooks/useWindowSize";
import { cn } from "@util/helpers";

type TextProps = {
  /** This is the function to set the state of the modal. */
  setIsShown: React.Dispatch<React.SetStateAction<boolean>>;
  /** This is the flag to check if the page is an article page. */
  isArticlePage?: boolean;
};
/**
 * The disclaimer text to be displayed.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=19037-69149&m=dev
 */
const Text = ({
  setIsShown,
  isArticlePage = false,
}: TextProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  const isShortText = !isScreenLG || isArticlePage;
  const text = getTaboolaDisclaimerText(isShortText);

  return (
    <div data-testid="text-component" className={cn("bg-gray-125 px-4 py-2")}>
      <p
        className={cn(
          "mb-0 text-center font-poppins text-xs font-normal leading-relaxed tracking-normal",
          "md:flex md:items-center md:justify-between md:gap-2 md:text-left"
        )}
      >
        <span>{text}</span>

        <LearnMore setIsShown={setIsShown} />
      </p>
    </div>
  );
};

export default Text;
